import { useContext } from 'react';

import { ToastComponent } from '../../components/ToastComponent';
import {
  GET_JOB_POSITION_CATALOG,
  GET_JOB_POSITION_CATALOG_SUCCESS,
  GET_JOB_POSITION_CATALOG_ERROR,
} from '../../constants/constantsRed';
import { StoreContext } from '../../context/Provider';
import useApi from '../../services/request.service';

export const useJobPositionCatalog = () => {
  const {
    getjobPositionCatalogState,
  } = useContext(StoreContext);
  const { genericApiConfiguration } = useApi();

  const getjobPositionCatalog = async () => {
    getjobPositionCatalogState.dispatch({ type: GET_JOB_POSITION_CATALOG });
    try {
      const result: any = await genericApiConfiguration(
        '/job-position',
        'GET',
        {},
        {},
        {}
      );
      if (result.status === 200) {
        const payload = result.data.message;
        getjobPositionCatalogState.dispatch({
          type: GET_JOB_POSITION_CATALOG_SUCCESS,
          payload: payload,
        });
      }
      return result;
    } catch (error: any) {
      ToastComponent(
        'warning',
        'Error',
        'La operación falló, inténtelo más tarde por favor.'
      );
      getjobPositionCatalogState.dispatch({
        type: GET_JOB_POSITION_CATALOG_ERROR,
        payload: error.message,
      });
      return 'error';
    }
  };

  return {
    getjobPositionCatalog
  };
};
